import React,{useState,useEffect} from 'react';
import { Checkbox, CircularProgress, Fab, FormControlLabel, Tooltip } from '@material-ui/core';
import {DragDropContext,Droppable,Draggable} from "react-beautiful-dnd";
import { Add, CollectionsBookmarkOutlined, Save } from '@material-ui/icons';
import { useHistory,useParams } from 'react-router-dom';
import Column from '../../../Components/Row';
import Input from '../../../Components/Input';
import Variable from '../../../Components/Menu/Variable';
import Row from '../../../Components/Column';
import realtimeDB from '../../../Utils/api';
import styled from "styled-components";
import usePrivilegios from "../../../Hooks/usePrivilegios";

const ProductoNombre=styled.h2`
margin:15px;`;

const StyleLoading=
{
    position: "absolute",
    top: "50%",
    left: "50%",
    marginTop: "-50px",
    marginLeft:" -50px",
    width:" 100px",
    height: "100px"
}

const StyleFAB=
{
    display:"grid",
    position: "absolute",
    bottom: 0,
    right: 0,
    margin: "20px",
}

const VariablesList = () => 
{
    const History=useHistory();
    const Params=useParams();

    const [Producto, setProducto] = useState(undefined);
    const [NombreVariacion, setNombreVariacion] = useState("");
    const [DescripcionCortaVariacion, setDescripcionCortaVariacion] = useState("");
    const [PrecioVariacion, setPrecioVariacion] = useState("");
    const [PrecioPrincipal, setPrecioPrincipal] = useState(false);
    const [ActualizarOrder, setActualizarOrder] = useState(false);
    const {id,categoria}=useParams();

    const [Loading, setLoading] = useState(true);

    const [ActualizandoVariables, setActualizandoVariables] = useState(false);
    
    useEffect(async() => 
    {
      const fetchData=async ()=>
      {
        realtimeDB.ref(`/Menu/CategoriasDOS/${categoria}/Items/${id}`).on("value",snapshot => 
        {
           setProducto(snapshot.val());
           setLoading(false);
        });
      } 

      fetchData();
    }, []);

    const CheckActivado=()=>
    {
        if(NombreVariacion==="" || PrecioVariacion==="")
        {
            return true;
        }
        return false;
    }

    const SaveOrder=async()=>
    {
        setActualizandoVariables(true);
        const ArrayVariables=Object.entries(Producto.Variables)
        await realtimeDB.ref(`/Menu/CategoriasDOS/${categoria}/Items/${id}/Variables`).set(null);
        for (let index = 0; index < ArrayVariables.length; index++) 
        {
            const Variable = ArrayVariables[index][1];
            await realtimeDB.ref(`/Menu/CategoriasDOS/${categoria}/Items/${id}/Variables`).push(Variable);
        }
        setActualizandoVariables(false);
    }

    const addVariable=async ()=>
    {
        const getUID=()=>
        {
            let uniqueId = Date.now().toString(36) + Math.random().toString(36).substring(2);
            return uniqueId
        }
        
        await realtimeDB.ref(`/Menu/CategoriasDOS/${categoria}/Items/${id}/Variables/${getUID()}`).set(
        {
            Nombre:NombreVariacion,
            Descripcion:DescripcionCortaVariacion,
            Precio:PrecioVariacion,
            esPrecioPrincipal:PrecioPrincipal
        });
        setNombreVariacion("");
        setPrecioVariacion("0");
        setPrecioPrincipal(false);
        setDescripcionCortaVariacion("");
    }
   
    if(Loading)
    {
        return <CircularProgress style={StyleLoading}/>;
    }

    const Variables=()=>
    {
        const OrdenadorVariables=async result=>
        {
            var VariableArray=Object.entries(Producto.Variables);
           
            if(VariableArray.length>1)
            {
                const [variablesOrdenadas]=VariableArray.splice(result.source.index,1);
                VariableArray.splice(result.destination.index,0,variablesOrdenadas);
                VariableArray=VariableArray.map(variable => 
                {
                   return { id: variable[0] , data:variable[1] }
                });

                var variables={};
                VariableArray.map(variable =>
                {
                    variables[variable.id] = variable.data;
                })
                var productoActualizado={...Producto,Variables:variables}

                setProducto(productoActualizado);
                setActualizarOrder(true);

            }
        }

        if(ActualizandoVariables)
        {
            return <CircularProgress style={StyleLoading}/>;
        }

        if(Producto.Variables)
        {
            var VariableArray=Object.entries(Producto.Variables);

            VariableArray=VariableArray.sort((a,b) => (a[1].Indice > b[1].Indice) ? 1 : ((b[1].Indice > a[1].Indice) ? -1 : 0));

            return <DragDropContext  onDragEnd={OrdenadorVariables}>
                <Droppable droppableId='Variables'>
                    {droppableProvided => <div {...droppableProvided.droppableProps} ref={droppableProvided.innerRef}>
                        {VariableArray.map((variable,index)=>
                        {

                             return <Draggable key={variable[0]} draggableId={variable[0]}  index={index}>
                                 {draggableProvided => (<div {...draggableProvided.draggableProps} ref={draggableProvided.innerRef} {...draggableProvided.dragHandleProps}>
                                    <Variable variable={{id:variable[0],data:variable[1]}} idProducto={id}/>
                                 </div>  )}
                             </Draggable>
                        })}
                        {droppableProvided.placeholder}
                    </div>}
                </Droppable>
            </DragDropContext>
        }
        
        return <p style={{textAlign:"center",fontSize:"30px"}}>Sin variables</p>
    }

    const FABs=()=>
    {
        const FAB=({title,placement,icon,margin,onClick})=>
        {
            return <Tooltip title={title} placement={placement}>
            <Fab  style={{ background:"#0088FF",margin}} color="primary" onClick={onClick} >
                {icon}
            </Fab>
            </Tooltip>
        }

        return <div style={StyleFAB}>
            {!CheckActivado() &&  <FAB title="Agregar" placement="top" icon={<Add/>} margin="10px 0" onClick={addVariable}/>}
            {ActualizarOrder && <FAB title="Guardar" placement="left" icon={<Save/>} margin="0" onClick={async ()=> SaveOrder()}/>}
        </div> 
    }

    return (
        <div className='container'>
           <ProductoNombre style={{textAlign:"center"}}>{Producto.Nombre}</ProductoNombre>
           <div style={{padding:"10px 0"}}>
                <Column >
                     <Row>
                          <Input label="Nombre" value={NombreVariacion} changeValue={setNombreVariacion} styleCSS={{padding:"10px"}}/>
                          <Input label="Precio" type='number' value={PrecioVariacion} changeValue={setPrecioVariacion} styleCSS={{padding:"10px"}}/>
                          <div style={{justifySelf:"center"}}><FormControlLabel control={<Checkbox checked={PrecioPrincipal} onChange={e => setPrecioPrincipal(e.target.checked)} />} label="Precio principal"/></div>
                     </Row>
                     <Input label="Descripcion" value={DescripcionCortaVariacion} changeValue={setDescripcionCortaVariacion} styleCSS={{padding:"10px"}}/>
                </Column>
           </div>
           <Variables/>
           <FABs/>
        </div>
    )
}

export default VariablesList
